import { useDatabase } from '../composables/database'
import { Order } from '../store/useOrders'

type OrdersModelReturn = {
  /**Return all orders on device */
  getAll: () => Promise<Order[]>
  /**Writes orders to device */
  writeOrders: (data: Order[]) => Promise<void>
  /**Removes all orders from device */
  clearOrders: () => Promise<void>
}
export const OrdersModel = (): OrdersModelReturn => {
  const { run, query } = useDatabase()

  const getAll = async () => {
    const sql = `
        SELECT * FROM orders ORDER BY id DESC;
        `
    return await query(sql)
      .catch((error) => console.log(`Error grabbing all orders: ${error}`))
      .then((orders) => {
        if (orders && orders.length) {
          return JSON.parse(orders[0]['orders_data']).map((order: Order) => {
            return { ...order, date: new Date(order.date) }
          })
        } else {
          return []
        }
      })
  }

  const writeOrders = async (data: Order[]) => {
    const sql = `
        INSERT OR REPLACE INTO orders ('id', 'orders_data')
        VALUES ((SELECT id FROM orders WHERE id = 1), ?);
    `
    await run(sql, [JSON.stringify(data)]).catch((error) =>
      console.log(`Error writing orders to DB: ${error}`)
    )
  }
  const clearOrders = async () => {
    const sql = 'DELETE FROM orders;'
    await run(sql, []).catch((error) => console.log(`Error deleting orders: ${error}`))
  }

  return {
    getAll,
    writeOrders,
    clearOrders,
  }
}
